import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Fade,
  FormControl,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, Ref } from "react";
import { Link, useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import { useRegister } from "../api/effects/mutations/register";
import useFetchAllActiveDivisi from "../api/effects/queries/Divisi/useFetchAllActiveDivisi";
import InputDate from "../components/InputDate";
import { WarningModal } from "../components/WarningModal";
import { AllDivisiActiveResponse } from "../models/Divisi";
import { AddRiwayatPekerjaanPayload } from "../models/RiwayatPekerjaan";
import { AddRiwayatPendidikanPayload } from "../models/RiwayatPendidikan";
import { convertDate, toIsoStringDate } from "../utils/dateConvert";
import PekerjaanTerakhirModal from "./Components/PekerjaanTerakhirModal";
import PendidikanTerakhirModal from "./Components/PendidikanTerakhirModal";
import DataPrivacyModal from "./Components/DataPrivacyModal";

const RootGrid = styled(Grid)(({ theme }) => ({
  height: "100%",
  minHeight: "90vh",
  paddingTop: "5vh",
  paddingBottom: "5vh",
  [theme.breakpoints.up("md")]: {
    paddingRight: "30vw",
  },
  [theme.breakpoints.up("lg")]: {
    paddingRight: "40vw",
  },
}));

const SquareGrid = styled(Grid)({
  height: "auto",
  width: "100%",
  maxWidth: "90vw",
  padding: "2%",
});

const ClearLink = styled(Link)({
  color: "#150A33",
  textDecoration: "none",
  fontSize: ".8em",
});

const ItemGrid = styled(Grid)({
  width: "100%",
  textAlign: "center",
  padding: "1%",
});

const BoxButtonText = styled(Box)({
  width: "90%",
  height: "auto",
  textAlign: "start",
  padding: "5%",
});

const ButtonFull = styled(Button)({
  margin: "3%",
  width: "40%",
});

const InputTextField = styled(TextField)({
  width: "90%",
});

const InputButton = styled(Button)({
  width: "90%",
});

const InputFormGroup = styled(FormGroup)({
  justifyContent: "center",
  alignContent: "center",
});

const HelperTypography = styled(Typography)({
  fontSize: "0.75rem",
  marginLeft: "14px",
  marginTop: "3px",
  marginRight: "14px",
  marginBottom: "0",
});

export default function RegisterPage() {
  const [namaDepan, setNamaDepan] = useState("");
  const [email, setEmail] = useState("");
  const [namaBelakang, setNamaBelakang] = useState("");
  const [tanggalLahir, setTanggalLahir] = useState(toIsoStringDate(Date.now()));
  const [nomorHandphone, setNomorHandphone] = useState("");
  const [ketertarikanBidang, setKetertarikanBidang] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pendidikanTerakhir, setPendidikanTerakhir] =
    useState<AddRiwayatPendidikanPayload>({
      PENDIDIKAN_ID: "",
      NAMA_INSTITUSI: "",
      KOTA: "",
      JURUSAN: "",
      TAHUN_MULAI: toIsoStringDate(Date.now()),
      TAHUN_SELESAI: toIsoStringDate(Date.now()),
      PEMBIAYAAN: "",
      LULUS: false,
    });
  const [pekerjaanTerakhir, setPekerjaanTerakhir] =
    useState<AddRiwayatPekerjaanPayload>({
      NAMA_PERUSAHAAN: "",
      JENIS_USAHA: "",
      JABATAN_AWAL: "",
      JABATAN_AKHIR: "",
      TAHUN_MASUK: toIsoStringDate(Date.now()),
      TAHUN_KELUAR: toIsoStringDate(Date.now()),
      JUMLAH_KARYAWAN: 0,
      NAMA_ATASAN_LANGSUNG: "",
      NAMA_DIREKTUR: "",
      GAJI_TERAKHIR: 0,
      ALASAN_BERHENTI: "",
    });

  const [pekerjaanModalState, setPekerjaanModalState] = useState(false);
  const handleEditPekerjaan = (e: AddRiwayatPekerjaanPayload) => {
    setPekerjaanTerakhir(e);
  };
  const handlePekerjaanModal = () => {
    setPekerjaanModalState(!pekerjaanModalState);
  };

  const [pendidikanModalState, setPendidikanModalState] = useState(false);
  const handleEditPendidikan = (e: AddRiwayatPendidikanPayload) => {
    setPendidikanTerakhir(e);
  };
  const handlePendidikanModal = () => {
    setPendidikanModalState(!pendidikanModalState);
  };

  const handleTanggalLahir = (e: any) => {
    setTanggalLahir(e);
  };

  const { data: allActiveDivisiData } = useFetchAllActiveDivisi();
  const [Divisidata, setDivisiData] = useState<AllDivisiActiveResponse[]>([]);
  useEffect(() => {
    if (allActiveDivisiData !== undefined) {
      setDivisiData(allActiveDivisiData);
    }
  }, [allActiveDivisiData]);

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const navigate = useNavigate();

  const [warningModalState, setWarningModalState] = useState(false);
  const [warningModalText, setWarningModalText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const { mutateAsync: register } = useRegister({
    onSuccess(data) {
      setWarningModalText("Register Successful Please Confirm Email");
      setWarningModalState(true);
    },
    onError(data: any) {
      setWarningModalText(data.response?.data || "Terjadi kesalahan saat pendaftaran");
      setWarningModalState(true);
    },
  });

  const handleValidateFormAndOpenModal = () => {
    if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setWarningModalText("Invalid Email.");
      setWarningModalState(true);
      return;
    }
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(password)) {
      setWarningModalText(
        "Minimum 8 characters including at least one of each uppercase, lowercase, and number."
      );
      setWarningModalState(true);
      return;
    }
    if (password !== confirmPassword) {
      setWarningModalText("Password Not Same.");
      setWarningModalState(true);
      return;
    }
    if (namaDepan.trim() === "") {
      setWarningModalText("Nama Depan Wajib diisi.");
      setWarningModalState(true);
      return;
    }
    if (namaBelakang.trim() === "") {
      setWarningModalText("Nama Belakang Wajib diisi.");
      setWarningModalState(true);
      return;
    }
    if (convertDate(tanggalLahir) === convertDate(Date.now())) {
      setWarningModalText("Tanggal Lahir Wajib diisi.");
      setWarningModalState(true);
      return;
    }
    if (nomorHandphone === "") {
      setWarningModalText("Nomor Handphone Wajib diisi.");
      setWarningModalState(true);
      return;
    }

    if (ketertarikanBidang === "") {
      setWarningModalText("Ketertarikan Bidang Wajib diisi.");
      setWarningModalState(true);
      return;
    }
    if (
      pendidikanTerakhir.PENDIDIKAN_ID === "" ||
      pendidikanTerakhir.NAMA_INSTITUSI === "" ||
      pendidikanTerakhir.KOTA === "" ||
      pendidikanTerakhir.JURUSAN === "" ||
      pendidikanTerakhir.TAHUN_MULAI === "" ||
      pendidikanTerakhir.TAHUN_SELESAI === "" ||
      pendidikanTerakhir.PEMBIAYAAN === ""
    ) {
      setWarningModalText("Pendidikan Terakhir Wajib diisi.");
      setWarningModalState(true);
      return;
    }
    setModalOpen(true);
  };

  const executeRegistration = () => {
    setModalOpen(false);
    register({
      EMAIL: email,
      NAMA_DEPAN: namaDepan,
      NAMA_BELAKANG: namaBelakang,
      TANGGAL_LAHIR: toIsoStringDate(tanggalLahir),
      NOMOR_HANDPHONE: nomorHandphone,
      KETERTARIKAN_BIDANG: ketertarikanBidang,
      RIWAYAT_PENDIDIKAN: pendidikanTerakhir,
      RIWAYAT_PEKERJAAN: pekerjaanTerakhir.JABATAN_AKHIR !== "" ? pekerjaanTerakhir : null,
      PASSWORD: password,
      CONFIRM_PASSWORD: confirmPassword,
    });
  };

  const onFormSubmit = (e: any) => {
    e.preventDefault();
    handleValidateFormAndOpenModal();
  };

  const handleClosePrivacyModal = () => {
    setModalOpen(false);
  };

  return (
    <Box
      sx={{
        marginTop: "0",
        height: "100%",
        minHeight: "100vh",
        width: "100%",
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/TowerWhiteBG.png)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <PekerjaanTerakhirModal
        open={pekerjaanModalState}
        value={pekerjaanTerakhir}
        handleClose={handlePekerjaanModal}
        handleEdit={handleEditPekerjaan}
      />
      <PendidikanTerakhirModal
        open={pendidikanModalState}
        value={pendidikanTerakhir}
        handleClose={handlePendidikanModal}
        handleEdit={handleEditPendidikan}
      />
      <WarningModal
        open={warningModalState}
        handleClose={() => {
          setWarningModalState(false);
          if (warningModalText === "Register Successful Please Confirm Email") {
            navigate("/Login");
          }
        }}
        text={warningModalText}
      />
      <Fade in={true}>
        <RootGrid container justifyContent="center" alignItems="center">
          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="center"
          >
            <ClearLink to="/">
              <Box
                component="img"
                src={`${process.env.PUBLIC_URL}/images/LogoIndomobilCareer.png`}
                alt="IndomobilCareerLogo"
                sx={{
                  width: {
                    xs: 280,   // small phones
                    sm: 480,   // tablets
                    md: 540,   // laptops
                    lg: 270,   // desktops
                    xl: 540,   // large desktops
                  },

                }}
              />
            </ClearLink>
          </Grid>
          <SquareGrid
            item
            xs={12}
            sm={9}
            md={6}
            spacing={1}
            container
            alignItems="center"
            justifyContent="center"
            direction="column"
          >
            <form
              onSubmit={onFormSubmit}
              style={{
                height: "auto",
                width: "100%",
                maxWidth: "90vw",
                padding: "2%",
              }}
            >
              <ItemGrid item>
                <Typography variant="h5">Start Your Carrer Now</Typography>
              </ItemGrid>
              <ItemGrid item>
                <InputTextField
                  variant="outlined"
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </ItemGrid>
              <ItemGrid item>
                <InputTextField
                  variant="outlined"
                  label="Nama Depan"
                  value={namaDepan}
                  onChange={(e) => setNamaDepan(e.target.value)}
                />
              </ItemGrid>
              <ItemGrid item>
                <InputTextField
                  variant="outlined"
                  label="Nama Belakang"
                  value={namaBelakang}
                  onChange={(e) => setNamaBelakang(e.target.value)}
                />
              </ItemGrid>
              <ItemGrid item>
                <Flatpickr
                  render={({ ...props }, ref: Ref<HTMLInputElement>) => {
                    return (
                      <InputTextField
                        label="Tanggal Lahir"
                        value={convertDate(tanggalLahir)}
                        inputRef={ref}
                      />
                    );
                  }}
                  value={convertDate(tanggalLahir)}
                  options={{
                    allowInput: true,
                    dateFormat: "j/n/Y",
                  }}
                  onChange={(e: any) => handleTanggalLahir(e[0])}
                />
              </ItemGrid>
              <ItemGrid item>
                <InputTextField
                  variant="outlined"
                  label="Nomor Handphone"
                  value={nomorHandphone}
                  onChange={(e) => setNomorHandphone(e.target.value)}
                />
              </ItemGrid>
              <ItemGrid item>
                <FormControl sx={{ width: "90%" }}>
                  <InputLabel id="bidang">Ketertarikan Bidang</InputLabel>
                  <Select
                    labelId="bidang"
                    id="bidang-select"
                    sx={{ textAlign: "start" }}
                    value={ketertarikanBidang}
                    label="Ketertarikan Bidang"
                    onChange={(e) => setKetertarikanBidang(e.target.value)}
                  >
                    {Divisidata.map((value, key) => (
                      <MenuItem value={value.value} key={key}>
                        {value.text}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </ItemGrid>
              <ItemGrid item>
                <InputTextField
                  variant="outlined"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="start"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  helperText="Minimum 8 characters including at least one of each uppercase, lowercase, and number."
                />
              </ItemGrid>
              <ItemGrid item>
                <InputTextField
                  variant="outlined"
                  label="Confirm Password"
                  type={showPassword ? "text" : "password"}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="start"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  helperText="Must Matched With Password"
                />
              </ItemGrid>

              <ItemGrid item>
                {pendidikanTerakhir.JURUSAN !== "" &&
                  pendidikanTerakhir.NAMA_INSTITUSI !== "" ? (
                  <BoxButtonText>
                    <Typography variant="h6">Pendidikan Terakhir</Typography>
                    <Typography>
                      {pendidikanTerakhir.JURUSAN} ,{" "}
                      {pendidikanTerakhir.NAMA_INSTITUSI}
                    </Typography>
                  </BoxButtonText>
                ) : (
                  ""
                )}
                <InputFormGroup>
                  <InputButton
                    variant="contained"
                    onClick={handlePendidikanModal}
                  >
                    Tambah Pendidikan Terakhir
                  </InputButton>
                  <FormHelperText sx={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginLeft: "14px",
                    marginTop: "3px",
                    marginRight: "14px",
                    marginBottom: "0",
                  }}>
                    *Pendidikan Terakhir Wajib Diisi
                  </FormHelperText>
                </InputFormGroup>
              </ItemGrid>

              <ItemGrid item>
                {pekerjaanTerakhir.JABATAN_AKHIR !== "" &&
                  pekerjaanTerakhir.NAMA_PERUSAHAAN !== "" ? (
                  <BoxButtonText>
                    <Typography variant="h6">Pekerjaan Terakhir</Typography>
                    <Typography>
                      {pekerjaanTerakhir.JABATAN_AKHIR} ,{" "}
                      {pekerjaanTerakhir.NAMA_PERUSAHAAN}
                    </Typography>
                  </BoxButtonText>
                ) : (
                  ""
                )}

                <InputFormGroup>
                  <InputButton
                    variant="contained"
                    onClick={handlePekerjaanModal}
                  >
                    Tambah Pekerjaan Terakhir
                  </InputButton>
                  <FormHelperText sx={{
                    fontSize: "0.75rem",
                    marginLeft: "14px",
                    marginTop: "3px",
                    marginRight: "14px",
                    marginBottom: "0",
                  }}>
                    *Pekerjaan Terakhir Tidak Wajib Diisi
                  </FormHelperText>
                </InputFormGroup>
              </ItemGrid>

              <ItemGrid item>
                <ButtonFull
                  variant="outlined"
                  onClick={handleValidateFormAndOpenModal}
                >
                  <Typography color="black">
                    Register
                  </Typography>
                </ButtonFull>
              </ItemGrid>
            </form>
          </SquareGrid>
          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="center"
          >
            <ItemGrid item>
              <Typography>Already Have Account ?</Typography>
            </ItemGrid>
            <ItemGrid item>
              <ClearLink to="/Login">
                <Typography color="primary">Login</Typography>
              </ClearLink>
            </ItemGrid>
          </Grid>
        </RootGrid>
      </Fade>

      <DataPrivacyModal
        open={modalOpen}
        handleClose={handleClosePrivacyModal} 
        handleConfirm={executeRegistration}
      />
    </Box>
  );
}